// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { filter } from "../../../../io/hyperify/core/functions/filter";
import { find } from "../../../../io/hyperify/core/functions/find";
import { some } from "../../../../io/hyperify/core/functions/some";
import { Product } from "../../../../io/hyperify/core/store/types/product/Product";
import { useStoreProductList } from "../../../../io/hyperify/frontend/hooks/useStoreProductList";
import {
    MENU_ITEMS,
    ROUTE_RULES,
} from "../../core/constants/route";

import { MenuItem } from "../../core/types/MenuItem";



export function useMenuItems (): readonly MenuItem[] {

    const products : Product[] = useStoreProductList();

    return filter(
        MENU_ITEMS,
        (item: MenuItem): boolean => {

            const route = item.route;

            const rule = find(
                ROUTE_RULES,
                (item) : boolean => item.route === route
            );
            const enableIfProductsOf = rule?.enableIfProductsOf;

            if (enableIfProductsOf) {
                return some(products, (item: Product) : boolean => !item.onHold && !!item.published && some(enableIfProductsOf, type => type === item.type) );
            }

            return true;
        }
    );
}
